
import axiosFormData from './axiosFormData'
import upyunSignature from '@/utils/upyunSignature'
import _ from 'lodash'

let defaultHttp = ''
let fileUrl = process.env.FILEURL
if (process.env.NODE_ENV == "development") {
    defaultHttp = 'https://yme-res.aibiyme.cn'
    fileUrl = 'webappTestImages/'
}else {
    defaultHttp = 'https://yme-res.aibiyme.cn'
    fileUrl = 'webappImages/'
}

// 将base64转换为blob
const dataURLtoBlob = (dataurl) => {
    let arr = dataurl.split(","),
        mime = arr[0].match(/:(.*?);/)[1],
        bstr = atob(arr[1]),
        n = bstr.length,
        u8arr = new Uint8Array(n);
    while (n--) {
        u8arr[n] = bstr.charCodeAt(n);
    }
    return new Blob([u8arr], { type: mime });
}
 
// 将blob转换为file
const blobToFile = (theBlob, fileName) => {
    theBlob.lastModifiedDate = new Date();
    theBlob.name = fileName;
    return theBlob;
}


/**
 * file转base64
 * @param file 文件
 * @param callback 回调
 */
export const fileToBase64 = (file, callback) => {
    const fileReader = new FileReader()
    fileReader.readAsDataURL(file)
    fileReader.onload = function (e:any) {
        // callback(this.result)
        let image:any = new Image()     // 新建一个img标签（不嵌入DOM节点，仅做canvas操作)
        image.src = e.target.result    // 让该标签加载base64格式的原图
        image.onload = function () {    //图片加载完毕后再通过canvas压缩图片，否则图片还没加载完就压缩，结果图片是全黑的
            let canvas:any = document.createElement('canvas') //创建一个canvas元素
            let context:any = canvas.getContext('2d')    //context相当于画笔，里面有各种可以进行绘图的API
            // 定义 canvas 大小，也就是压缩后下载的图片大小
            let imageWidth:any = image.width; // 压缩后图片的宽度
            let imageHeight:any = image.height; // 压缩后图片的高度
            canvas.width = imageWidth;
            canvas.height = imageHeight;

            // 使用drawImage重新设置img标签中的图片大小，实现压缩
            context.drawImage(image, 0, 0, imageWidth, imageHeight)
            // 图片截取指定位置载入
            callback(canvas.toDataURL(`image/jpg`))
        };
    }
}


/**
 * 
 * @param file 文件 或者base64 地址
 * @param dirUrl 又拍云文件夹路径
 * @param type 是否上传base64 如果是base64 需要先转成file
 * @returns 
 */

const mockUpload = async(file: File, dirUrl = fileUrl, type = '') => {
    try {
        const _signature = upyunSignature({
            dirUrl
        })
        let _file:any = file
        if( type === 'base64' ) {
            let blob = dataURLtoBlob(file);
            _file = blobToFile(blob, 'fileName');
        }
        const formData = new FormData()
        formData.append('policy', _signature.policy)
        formData.append('signature', _signature.signature)
        formData.append('file', _file)
        const res: any = await axiosFormData('//v0.api.upyun.com/ai-files', formData)
        const fileItem = {
            // key:`${defaultHttp}${res.url}`,
            url: `${defaultHttp}${res.url}`
            // thumbnailUrl:`${defaultHttp}${res.url}`,
            // extra:''
        }
        return fileItem
    } catch (error) {
        console.log(error)
        throw new Error(error)
    }
}


export default mockUpload